<template>
  <el-dialog title="辅助材料" :append-to-body="true" :close-on-click-modal="false" width="55%" :visible.sync="viewData.visible">
      <el-tabs>
        <el-tab-pane :key="2" label="辅助材料">
          <el-table :data="dataList" row-key="item" size="mini" border :header-cell-style="{background:'#f5f5f5'}" style="width: 100%;" :default-expand-all="false">
            <el-table-column type="index" width="50" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="item" header-align="center" align="left" label="项目">
              <template slot-scope="scope">
                {{ ITEM_VALUE(scope.row.item) }}
              </template>
            </el-table-column>
            <el-table-column prop="unitPrice" header-align="center" align="right" label="单价">
              <template slot-scope="scope">
                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="scope.row.unitPrice" placeholder="单价"></ctl-number>
                <span v-else>{{scope.row.unitPrice}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="consumption" header-align="center" align="right" label="每小时消耗量">
              <template slot-scope="scope">
                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="scope.row.consumption" placeholder="每小时消耗量"></ctl-number>
                <span v-else>{{scope.row.consumption}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="averageCost" header-align="center" align="right" label="每小时平均成本">
              <template slot-scope="scope">
                <ctl-number :precision="3" :min="0" v-if="viewFlag !== 'view'" v-model="scope.row.averageCost" placeholder="每小时平均成本"></ctl-number>
                <span v-else>{{scope.row.averageCost}}</span>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="viewData.visible = false">
            取消
        </el-button>
        <el-button size="mini" type="primary" v-if="viewFlag != 'view'" plain @click="dataFormSubmit()">
            提交
        </el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  getRfqPartProcessMaterialsAll,
  createRfqQuotationAuxiliaryMaterialsBatch,
  editRfqQuotationAuxiliaryMaterialsBatch
} from '@/controller/quotation'
import moment from 'moment'
import {
  getITEM_VALUE,
} from "@/utils/const";
import CtlNumber from '@/views/common/ctl-number'
export default {
  components: {
    CtlNumber
  },
  data() {
    return {
      viewData: {
        visible: false,
        width: ''
      },
      viewFlag: '',
      dataList: [
        {
          id:'',
          item:'0',
          unitPrice:0,
          consumption:0,
          averageCost:0
        },
        {
          id:'',
          item:'1',
          unitPrice:0,
          consumption:0,
          averageCost:0
        },
        {
          id:'',
          item:'2',
          unitPrice:0,
          consumption:0,
          averageCost:0
        },
        {
          id:'',
          item:'3',
          unitPrice:0,
          consumption:0,
          averageCost:0
        },
        {
          id:'',
          item:'4',
          unitPrice:0,
          consumption:0,
          averageCost:0
        }
      ],
      inDataList:[], //数据库中的原数据
      dataForm: {
        rfqId: '',
        rfqPartId: '',
        rfqSupplierId: '',
        roundNo: '',
        manufacturingProcess: '',
        theNumberOfDirect: '',
        perCapitaLaborCosts: '',
        personnelProportion: '',
        labor: '',
        investment: '',
        yearsOfDepreciation: '',
        annualStartTime: '',
        depreciationPerHour: '',
        auxiliaryMaterials: '',
        summation: '',
      },
      ITEM_VALUE: getITEM_VALUE,
    }
  },
  mounted() {},
  methods: {
    init(id, viewFlag, data) {
      this.viewFlag = viewFlag
      this.dataForm = data ? data : this.dataForm
      this.viewData.visible = true
      this.initMaterials();
    },
    initMaterials() {
      getRfqPartProcessMaterialsAll({
        rfqId: this.dataForm.rfqId,
        rfqSupplierId: this.dataForm.rfqSupplierId,
        rfqPartId: this.dataForm.rfqPartId,
        roundNo:this.dataForm.roundNo
      }).then((data) => {
        if (data && data.code === "00") {
          this.inDataList = data.body;  //将数据库中获取到的原数据备份一份儿
          this.setDataList(data.body,this.dataList)
          this.totalPage = data.body.total
        } else {
          this.dataList = [];
          this.totalPage = 0
        }
      });
    },
    setDataList(fromData,toData){
      for(var i = 0;i<toData.length;i++){
        for(var j = 0 ;j<fromData.length;j++){
          if(toData[j].item === fromData[i].item){
            toData[j].id = fromData[i].id;
            toData[j].item = fromData[i].item;
            toData[j].unitPrice = fromData[i].unitPrice;
            toData[j].consumption = fromData[i].consumption;
            toData[j].averageCost = fromData[i].averageCost;
          }
        }
      }
    },
    //  新增 / 修改 辅助材料
    addOrUpdateAuxiliaryMaterials(id) {
      this.addOrUpdateAuxiliaryMaterialsVisible = true;
      this.$nextTick(() => {
        this.$refs.AddOrUpdatAuxiliaryMaterials.init(id, this.viewFlag, this.dataForm);
      });
    },

    //判断当前数据是否在原数据库中存在且未发生改变
    isHaveSameData(fromData){
      for(var j = 0 ; j < this.inDataList.length ; j++){
        //如果发现当前数组中的元素和原数据库中的数据一样，则无需更新或创建
        if(
            fromData!=null && this.inDataList[j]!=null &&
            fromData.id === this.inDataList[j].id &&
            fromData.item === this.inDataList[j].item &&
            fromData.unitPrice === this.inDataList[j].unitPrice &&
            fromData.consumption === this.inDataList[j].consumption &&
            fromData.averageCost === this.inDataList[j].averageCost
        ) {
/*          console.log(
              "fromData.id:" + fromData.id + " this.inDataList[j].id:" + this.inDataList[j].id +
              "fromData.item:" + fromData.item + " this.inDataList[j].item:" + this.inDataList[j].item +
              "fromData.unitPrice:" + fromData.unitPrice + " this.inDataList[j].unitPrice:" + this.inDataList[j].unitPrice +
              "fromData.consumption:" + fromData.consumption + " this.inDataList[j].consumption:" + this.inDataList[j].consumption +
              "fromData.averageCost:" + fromData.averageCost + " this.inDataList[j].averageCost:" + this.inDataList[j].averageCost
          )*/
          return true;
        }
      }
      return false;
    },

    // 表单提交
    dataFormSubmit() {
      // console.log("dataList:",JSON.stringify(this.dataList))
      // console.log("inDataList:",JSON.stringify(this.inDataList))
      var createArr = [];
      var updateArr = [];
      for(var i = 0 ; i < this.dataList.length ; i++){
        if(this.dataList[i].unitPrice === '' || isNaN(this.dataList[i].unitPrice) ||
            this.dataList[i].consumption === '' || isNaN(this.dataList[i].consumption) || this.dataList[i].averageCost === '' || isNaN(this.dataList[i].averageCost)){
          this.$message.info("不允许存在空值，请输入具体数值")
          return ;
        }
        // console.log("是否存在：",this.isHaveSameData(this.dataList[i]))
        //如果存在和原数据库不同的数据，则进行更新或创建
        if(!this.isHaveSameData(this.dataList[i])){
          var param = {
            id:this.dataList[i].id,
            rfqId:this.dataForm.rfqId,
            rfqSupplierId:this.dataForm.rfqSupplierId,
            rfqPartId:this.dataForm.rfqPartId,
            roundNo:this.dataForm.roundNo,
            item:this.dataList[i].item,
            unitPrice:this.dataList[i].unitPrice,
            consumption:this.dataList[i].consumption,
            averageCost:this.dataList[i].averageCost
          }
          //如果存在id，则为更新
          if(param.id !== ''){
            updateArr.push(param)
          }else{
            //如果不存在id，则为新建
            createArr.push(param)
          }
        }
      }
      if(createArr.length > 0){
        var params = {
            "list":createArr,
            "rfqId": this.dataForm.rfqId
        }
        createRfqQuotationAuxiliaryMaterialsBatch(params)
            .then((data) => {
              if (data && data.code === "00") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.viewData.visible = false;
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
      if(updateArr.length > 0){
        var params = {
            "list":updateArr,
            "rfqId": this.dataForm.rfqId
        }
        editRfqQuotationAuxiliaryMaterialsBatch(params)
            .then((data) => {
              if (data && data.code === "00") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                  duration: 1500,
                  onClose: () => {
                    this.viewData.visible = false;
                  },
                });
              } else {
                this.$message.error(data.msg);
              }
            })
            .catch((error) => {
              console.log(error);
            });
      }
    },
    getStyle() {
      return 'width: 240px; text-align: right'
    },
    getStyle2() {
      return 'width: 507.5px;'
    }
  }
}
</script>

<style lang="scss">
.el-dialog__body {
  .org-dialog-form {
    width: 100%;
  }
}

.linetext {
  white-space: pre-line;
}

.fr {
  float: right;
}
</style>
